import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const words = [
    "Logos",
    "Brand Marks",
    "Digital Marketing",
    "Social Graphics",
    "Email Design",
    "Print + Displays",
    "Publications",
    "Custom Creative",
  ];

  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-[#2D1B4E] bg-[#0b0618] py-8 md:py-10"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-text font-extrabold text-3xl md:text-6xl px-8 text-white/90">
              {w}
            </span>
            <span className="text-[#8A2BE2] text-3xl md:text-6xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
